import moment from "moment";

export default {
	methods: {
		formattedDate(timestamp) {
			return moment(timestamp).format("MMM Do, YYYY, h:mm:ss A");
		},
		formattedDateWithOutTime(timestamp){
			return moment(timestamp).format("MMM D, YYYY");
		},
		timeDifferenceBetweenGivenDates(laterDate, smallDate){
			let a = moment.utc(laterDate);
			let b = moment.utc(smallDate);
			let ms = a.diff(b);
			let d = moment.duration(ms);
			return d.format("HH:mm:ss");
		}
	}
}
